null


// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/PITLambda/RekognitionClient.ts